import React, { useState } from "react";

type CollapsibleProps = {
    title: string;
    children: React.ReactNode;
};

const Collapsible: React.FC<CollapsibleProps> = ({ title, children }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div style={{ marginBottom: "1rem" }}>
            <h3
                onClick={() => setIsOpen(!isOpen)}
                style={{
                    cursor: "pointer",
                    textAlign: "center",
                    userSelect: "none",
                    background: "#f5f5f5",
                    padding: "8px",
                    borderRadius: "6px",
                }}
            >
                {title} {isOpen ? "▲" : "▼"}
            </h3>
            {isOpen && <div style={{ padding: "8px" }}>{children}</div>}
        </div>
    );
};

export default Collapsible;
